import React from 'react';

function RadioInput(props) {
  const style = props.disabled ? 'disabled' : '';
  return (
    <span>
      <input
        type="radio"
        id={props.id}
        className={style}
        disabled={props.disabled}
        name={props.name}
        value={props.value}
        {...props.input}
      />
      <label className={style} htmlFor={props.id}>
        <span /><p>{props.label}</p>
      </label>
      { props.img && <img alt={props.name} src={props.img} />}
      {/* TODO Error handling should be done on a callback so that there isn't an error under every radio button
        props.meta.touched && props.meta.error && <p className="small error">{props.meta.error}</p>
      */}
    </span>
  );
}

RadioInput.propTypes = {
  input: React.PropTypes.object,
  meta: React.PropTypes.object,
};

export default RadioInput;



/** WEBPACK FOOTER **
 ** ./src/components/form-input-radio/index.js
 **/